import React, { useEffect } from 'react';
import { motion } from 'framer-motion';

const ConsultationForm = () => {
  useEffect(() => {
    // Load the Zcal embed script
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.src = 'https://static.zcal.co/embed/v1/embed.js';
    document.head.appendChild(script);

    // Cleanup function to remove script when component unmounts
    return () => {
      if (document.head.contains(script)) {
        document.head.removeChild(script);
      }
    };
  }, []);

  return (
    <section id="consultation" className="py-20 bg-slate-50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-6">
            Ready to Secure Your Digital Brand?
          </h2>
          <p className="text-xl text-slate-600">
            Schedule a confidential consultation to discuss your specific needs.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          viewport={{ once: true }}
          className="bg-white rounded-2xl p-8 shadow-xl"
        >
          <div className="zcal-inline-widget" data-zcal-options='{"showBackground":1}'>
            <a href="https://zcal.co/i/8uKAHv4y">Discovery Call - Schedule a meeting</a>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default ConsultationForm;